import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { Tag } from "@design-system/Tag/Tag";
import { ClientDetailsRow } from "../clientViewConfig";
import { EMPTY_CELL_VALUE } from "./lib";

export const PlanCell = ({
    renderValue,
    row,
}: CellContext<ViewTableFeatures, ClientDetailsRow, FLAT_RATE_PLANS>) => {
    if (row.original.type === "entity") {
        return EMPTY_CELL_VALUE;
    }

    const value = renderValue();

    if (!value) {
        return <span aria-label="No plan">-</span>;
    }

    const planName = flatRatePlanNames[value] ?? "Custom";

    return (
        <Tag color="neutral" outline>
            {planName}
        </Tag>
    );
};
